<template>
  <div class="container">
    <div class="searchBox_top">
      <!-- <el-button v-if="createParams.status!='submit'" type="primary" @click="save">{{$t('common.saveDraft')}}</el-button>保存 -->
      <el-button v-if="createParams.status!='submit'" type="primary" @click="submit">{{$t('common.submit')}}
      </el-button>
      <!--提交-->
      <!--<el-button v-if="createParams.status=='submit'" type="primary" @click="downloadPdf">
                {{$t('settlementUnit.DownloadPDF')}}
            </el-button>-->
      <!--下载PDF-->
      <el-button type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
    </div>
    <el-form :model="createParams" ref="createParams" :rules="rules" label-width="130px" :disabled="createParams.status=='submit'">
      <el-row>
        <el-col :span="8">
          <el-form-item :label="$t('common.createDate')" prop="createDate">
            <!--创建日期-->
            <el-input v-model.trim="createParams.createDate" clearable disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('common.createBy')" prop="creator">
            <!--创建人-->
            <el-input v-model.trim="createParams.creator" clearable disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('common.status')" prop="status">
            <!--状态-->
            <ic-select clearable table="TT_ENGAGEMENT" field="STATUS" v-model="createParams.status" disabled></ic-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('settlementUnit.SystemApplyNo')" prop="serialNo">
            <!--系统申请编号-->
            <el-input v-model.trim="createParams.serialNo" clearable disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>Supplier Information</span>
        </div>
        <span style="margin-bottom:10px;display:block;">1. Full Legal Name of the Supplier (in both Chinese and English)</span>
        <el-row>
          <el-form-item label="Chinese Name" prop="nameCn">
            <el-input v-model="createParams.nameCn" disabled></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="English Name" prop="nameEn">
            <el-input v-model="createParams.nameEn" disabled></el-input>
          </el-form-item>
        </el-row>
        <el-divider></el-divider>

        <span style="margin-bottom:10px;display:block;">2. Legal Entities to be covered by BRA (e.g., MCCL, CTC)</span>
        <el-row class="noLeft">
          <el-form-item>
            <el-input v-model="createParams.affiliates" type="textarea" autosize clearable maxlength="300" rows="3"></el-input>
          </el-form-item>
        </el-row>
        <el-row class="noLeft">
          <el-col :span="20">
            <el-form-item :label="$t('settlementUnit.enclosure')" prop="tmLawFileId">
              <el-upload style="float:left" ref="upload" action="upload" :http-request="uploadConfirm" :show-file-list="false" multiple name="file">
                <el-button slot="trigger" size="small" type="primary">
                  {{$t('common.selectFile')}}
                </el-button>
                <!--选取文件-->
              </el-upload>
            </el-form-item>
            <div :key="index" v-for="(item,index) in fileList" style="padding-bottom: 5px;">
              <el-link type="primary" @click.native="downloadFile(item)">{{item.documentName}}</el-link>
              <el-button type="danger" size="mini" style="margin-left: 20px;" icon="el-icon-delete" circle @click.native.prevent="deleteFile(item.tmDocumentId,index,fileList)">
              </el-button>
              <!--删除-->
            </div>
          </el-col>
        </el-row>
        <el-divider></el-divider>

        <span style="margin-bottom:10px;display:block;"><span style="color: red;">*</span>3. Product(s) to be Supplied</span>
        <el-form-item prop="productType" class="noLeft flexBox">
          <el-radio-group v-model="createParams.productType" @change="productContent=null;nonProductContent=null;">
            <el-row>
              <el-radio label="P">Protein</el-radio>
              <el-input v-model="productContent" clearable></el-input>
            </el-row>
            <el-row>
              <el-radio label="N">Non Protein</el-radio>
              <el-input v-model="nonProductContent" clearable></el-input>
            </el-row>
          </el-radio-group>
        </el-form-item>
        <el-divider></el-divider>

        <span style="margin-bottom:10px;display:block;"><span style="color: red;">*</span>4. List the provinces to receive products from this supplier</span>
        <el-row class="noLeft">
          <el-form-item prop="provinces">
            <el-input v-model="createParams.provinces" type="textarea" autosize clearable maxlength="300"></el-input>
          </el-form-item>
        </el-row>
        <span style="margin-bottom:10px;display:block;"><span style="color: red;">*</span>5. Expected Supply Period (when applicable)</span>
        <el-row>
          <el-form-item label="Start Date" prop="startDate" label-width="170px">
            <el-date-picker value-format="yyyy-MM-dd" v-model="createParams.startDate" type="date" :picker-options="pickerOptionsStart" :placeholder="$t('common.selDate')"></el-date-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="End Date (if relevant)" prop="endDate" label-width="170px">
            <el-date-picker value-format="yyyy-MM-dd" v-model="createParams.endDate" type="date" :picker-options="pickerOptionsEnd" :placeholder="$t('common.selDate')"></el-date-picker>
          </el-form-item>
        </el-row>
        <el-divider></el-divider>

        <span style="margin-bottom:10px;display:block;"><span style="color: red;">*</span>6. Required Qualification Documentation (scanned copies to be sent to Legal together with the completed form)</span>
        <el-form-item prop="licenseWithChop" class="noLeft flexBox">
          <span style="width: 500px;">a. Business License of the Supplier (with the company chop)</span>
          <!-- <el-radio-group v-model="createParams.licenseWithChop">
                        <el-radio label="Y" style="width: 20px">Y</el-radio>
                        <el-radio label="N" style="width: 20px">N</el-radio>
                    </el-radio-group> -->
          <el-upload style="float:left" ref="upload" action="upload" :http-request="uploadConfirm1" :show-file-list="false" multiple name="file">
            <el-button slot="trigger" size="small" type="primary">
              {{$t('common.selectFile')}}
            </el-button>
          </el-upload>
        </el-form-item>
        <span :key="index" v-for="(item,index) in fileList1" style="padding-bottom: 5px;margin-right:40px;">
          <el-link type="primary" @click.native="downloadFile(item)">{{item.documentName}}</el-link>
          <el-button type="danger" size="mini" style="margin-left: 20px;" icon="el-icon-delete" circle @click.native.prevent="deleteFile(item.tmDocumentId,index,fileList1)">
          </el-button>
          <!--删除-->
        </span>
        <el-form-item prop="certificateWithChop" class="noLeft flexBox">
          <el-row>
            <span style="width: 500px;">b. Production/Operation Certificate or equivalent (with the company chop)</span>
            <el-radio-group v-model="createParams.certificateWithChop" @change='certificateWithChopChange'>
              <el-radio label="Y" style="width: 20px">Y</el-radio>
              <el-radio label="N" style="width: 20px">N</el-radio>
            </el-radio-group>
            <el-upload style="margin-left:70px;" ref="upload" action="upload" :http-request="uploadConfirm2" :show-file-list="false" multiple name="file">
              <el-button slot="trigger" size="small" type="primary">
                {{$t('common.selectFile')}}
              </el-button>
            </el-upload>
          </el-row>
        </el-form-item>
        <span :key="index" v-for="(item,index) in fileList2" style="padding-bottom: 5px;margin-right:40px;">
          <el-link type="primary" @click.native="downloadFile(item)">{{item.documentName}}</el-link>
          <el-button type="danger" size="mini" style="margin-left: 20px;" icon="el-icon-delete" circle @click.native.prevent="deleteFile(item.tmDocumentId,index,fileList2)">
          </el-button>
          <!--删除-->
        </span>
        <el-form-item prop="processWithChop" class="noLeft flexBox">
          <el-row>
            <span style="width: 500px;">c. Importation Registration Process Completed (for imported food)</span>
            <el-radio-group v-model="createParams.processWithChop" @change='processWithChopChange'>
              <el-radio label="Y" style="width: 20px">Y</el-radio>
              <el-radio label="N" style="width: 20px">N</el-radio>
            </el-radio-group>
            <el-upload style="margin-left:70px;" ref="upload" action="upload" :http-request="uploadConfirm3" :show-file-list="false" multiple name="file">
              <el-button slot="trigger" size="small" type="primary">
                {{$t('common.selectFile')}}
              </el-button>
            </el-upload>
          </el-row>
        </el-form-item>
        <span :key="index" v-for="(item,index) in fileList3" style="padding-bottom: 5px;margin-right:40px;">
          <el-link type="primary" @click.native="downloadFile(item)">{{item.documentName}}</el-link>
          <el-button type="danger" size="mini" style="margin-left: 20px;" icon="el-icon-delete" circle @click.native.prevent="deleteFile(item.tmDocumentId,index,fileList3)">
          </el-button>
          <!--删除-->
        </span>
        <el-divider></el-divider>

        <span style="margin-bottom:10px;display:block;"><span style="color: red;">*</span>7. Required Information in the BRA</span>
        <div style="padding-bottom: 10px;">a. Supplier’s Business Contact (name, email address and phone number)
        </div>
        <el-form-item prop="contactName" class="noLeft flexBox" label="Name">
          <el-input v-model="createParams.contactName" clearable></el-input>
        </el-form-item>
        <el-form-item prop="contactEmail" class="noLeft flexBox" label="Email">
          <el-input v-model="createParams.contactEmail" clearable></el-input>
        </el-form-item>
        <el-form-item prop="contactPhone" class="noLeft flexBox" label="Address">
          <el-input v-model="createParams.contactPhone" clearable></el-input>
        </el-form-item>
        <div style="padding-bottom: 10px;">b. Signatory on behalf of the Supplier (if not the Legal
          Representative)
        </div>
        <el-form-item prop="signatory" class="noLeft flexBox">
          <el-input v-model="createParams.signatory" clearable></el-input>
        </el-form-item>
        <div style="padding-bottom: 10px;">c. Title of the Signatory of BRA</div>
        <el-form-item prop="signatoryTitle" class="noLeft flexBox">
          <el-input v-model="createParams.signatoryTitle" clearable></el-input>
        </el-form-item>
        <div style="padding-bottom: 10px;">d. Registered Address</div>
        <el-form-item prop="registAddress" class="noLeft flexBox">
          <el-input v-model="createParams.registAddress" clearable></el-input>
        </el-form-item>
        <el-divider></el-divider>
      </el-card>
    </el-form>
  </div>

</template>

<script>
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import { apiService } from "../../../api/settlementUnit/engagement-file";
import { Message } from "element-ui";
import supplierApi from "@/api/supplier/supplier";

export default {
  components: { IcSelect },
  data() {
    return {
      createParams: {
        createDate: null,
        creator: null,
        status: null,
        serialNo: null,
        nameCn: null,
        nameEn: null,
        affiliates: null,
        productType: 'P',
        productContent: null,
        provinces: null,
        startDate: null,
        endDate: null,
        // licenseWithChop: 'Y',
        certificateWithChop: 'Y',
        processWithChop: 'Y',
        // businessContact: null,
        contactName: null,
        contactEmail: null,
        contactPhone: null,
        signatory: null,
        signatoryTitle: null,
        registAddress: null,
        supplierCode: null,
        tmSupplierId: null,
      },
      fileList: [],
      fileList1: [],
      fileList2: [],
      fileList3: [],
      productContent: null,
      nonProductContent: null,
      attachment: { documents: null, seq: '1', tsRecId: null, tsReckindId: 'TM_ENGAGEMENT' },
      rules: {
        affiliates: [{
          required: true,
          message: '请输入Any Other Affiliates to be Covered by BRA',
          trigger: 'blur'
        }],
        provinces: [{
          required: true,
          message: '请输入List the provinces to receive products from this supplier',
          trigger: 'blur'
        }],
        startDate: [{ required: true, message: '请选择Start Date', trigger: 'change' }],
        // endDate: [{required: true, message: '请选择End Date', trigger: 'change'}],
        // businessContact: [{
        //     required: true,
        //     message: '请输入Supplier’s Business Contact (name, email address and phone number)',
        //     trigger: 'blur'
        // }],
        contactName: [{ required: true, message: "不能为空", trigger: 'blur' }],
        contactEmail: [{ required: true, message: "不能为空", trigger: 'blur' }],
        contactPhone: [{ required: true, message: "不能为空", trigger: 'blur' }],
        signatory: [{
          required: true,
          message: '请输入 Signatory on behalf of the Supplier (if not the Legal Representative)',
          trigger: 'blur'
        }],
        signatoryTitle: [{ required: true, message: '请输入Title of the Signatory of BRA', trigger: 'blur' }],
        registAddress: [{
          required: true,
          message: '请输入Registered Address (City, Zip Code)',
          trigger: 'blur'
        }],
      },
      pickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.createParams.endDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.createParams.startDate;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
    }
  },
  created() {
    this.createParams.creator = localStorage.getItem("ms_username");
    this.createParams.createDate = this.$options.filters["dateFormatFilter"](new Date())
    this.id = this.$route.query.id;
    if (this.id) {
      this.getFiles();
      this.getFiles1();
      this.getFiles2();
      this.getFiles3();
      this.getById()
    } else {
      this.queryPrimaryKey()
    }
    let supplierObj = JSON.parse(localStorage.getItem("supplierObj"));
    if (supplierObj) {
      //this.obtainSupplierName()

      //下面的 原本在这里
    }

    this.createParams.nameCn = this.$route.query.supplierName
    this.createParams.nameEn = this.$route.query.supplierNameEn
    this.createParams.supplierCode = this.$route.query.accountNo
    this.createParams.tmSupplierId = this.$route.query.tmSupplierId
    if (this.createParams.tmSupplierId) {
      this.queryRegistAddress()
    }
  },
  methods: {
    //获取主键id
    queryPrimaryKey() {
      apiService.queryPrimaryKey().then(res => {
        if (res.code === '200') {
          this.id = res.data;
          this.createParams.tmEngagementId = res.data
        }
      });
    },
    //获取供应商地址
    queryRegistAddress() {
      let that = this
      apiService.queryRegistAddress(this.createParams.tmSupplierId).then(res => {
        if (res.code === '200') {
          that.createParams.registAddress = res.data
        }
      });
    },
    //查询详情
    getById() {
      apiService.getById(this.id).then(res => {
        this.createParams = res.data;
        if (this.createParams.productType === 'P') {
          this.productContent = this.createParams.productContent
        } else {
          this.nonProductContent = this.createParams.productContent
        }
      });
    },
    //下载PDF
    downloadPdf: function () {
      apiService.downloadPdf(this.id).then((res) => {
      })
    },
    //保存
    save() {
      if (this.createParams.productType === 'P') {
        this.createParams.productContent = this.productContent
      } else {
        this.createParams.productContent = this.nonProductContent
      }
      apiService.save(this.createParams).then(res => {
        if (res.code === '200') {
          Message({ message: this.$t('common.operateSuccess'), type: "success" });
          // this.historyBack()
          this.id = res.data
          this.getById()
        } else {
          Message({ message: res.msg, type: "error" });
        }
      });
    },
    //提交
    submit() {
      if (this.createParams.productType === 'P') {
        if (!this.productContent) {
          this.$message({ message: '请输入Product(s) to be Supplied后的文本框信息', type: "warning" });
          return
        } else {
          this.createParams.productContent = this.productContent
        }
      } else {
        if (!this.nonProductContent) {
          this.$message({ message: '请输入Product(s) to be Supplied后的文本框信息', type: "warning" });
          return
        } else {
          this.createParams.productContent = this.nonProductContent
        }
      }
      if (this.createParams.certificateWithChop == 'Y' && this.fileList2.length < 1) {//如果选择y 必须上传文件
        this.$message({ message: 'You have not uploaded the attachment, please upload.', type: "warning" });
        return false;
      }
      if (this.createParams.processWithChop == 'Y' && this.fileList3.length < 1) {//如果选择y 必须上传文件
        this.$message({ message: 'You have not uploaded the attachment, please upload.', type: "warning" });
        return false;
      }
      this.$refs['createParams'].validate((valid) => {
        if (valid) {
          apiService.submit(this.createParams).then(res => {
            if (res.code === '200') {
              Message({ message: this.$t('common.operateSuccess'), type: "success" });
              this.historyBack()
            } else {
              Message({ message: res.msg, type: "error" });
            }
          });
        } else {
          Message({ message: '请完成表格信息填写', type: "warning" });
          return false;
        }
      });
    },

    //文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.id;
      attachment.tsReckindId = 'TM_ENGAGEMENT';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },
    getFiles1: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.id;
      attachment.tsReckindId = 'Qualification1';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList1 = fileRes;
      })
    },
    getFiles2: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.id;
      attachment.tsReckindId = 'Qualification2';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList2 = fileRes;
      })
    },
    getFiles3: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.id;
      attachment.tsReckindId = 'Qualification3';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList3 = fileRes;
      })
    },
    //文件上传
    uploadConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = this.id;
        attachment.tsReckindId = 'TM_ENGAGEMENT';
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFiles();
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    uploadConfirm1: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = this.id;
        attachment.tsReckindId = 'Qualification1';
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFiles1();
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    uploadConfirm2: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = this.id;
        attachment.tsReckindId = 'Qualification2';
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFiles2();
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    uploadConfirm3: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = this.id;
        attachment.tsReckindId = 'Qualification3';
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFiles3();
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row)
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        //删除成功删除列表数据
        files.splice(index, 1);
      })
    },
    historyBack: function () {
      this.$router.go(-1);
    },
    certificateWithChopChange() {
      let that = this
      if (that.createParams.certificateWithChop != 'Y') {
        that.createParams.processWithChop = 'Y'
      }
    },
    processWithChopChange() {
      let that = this
      if (that.createParams.processWithChop != 'Y') {
        that.createParams.certificateWithChop = 'Y'
      }
    },

    //供应商名称赋值
    obtainSupplierName: function () {
      let that = this
      let tmSupplierId = this.createParams.tmSupplierId

      supplierApi.getResourceList({ tmSupplierId: tmSupplierId }).then((res) => {
        if (res.resultData.length == 1) {
          if (res.resultData[0].status == '0') {
            that.$message({ message: "供应商已被禁用", type: "warning" });
            return
          }
          that.createParams.nameCn = res.resultData[0].supplierName
          that.createParams.nameEn = res.resultData[0].supplierNameEn
        }
      })
    }
  }

}
</script>
<style lang="scss" scoped>
.searchBox_top {
  margin-bottom: 20px;
}

.el-table {
  margin-top: 10px;
}

.el-select {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}

.noLeft {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.el-card {
  // .el-select{
  //     width:20%;
  // }
  // .el-date-editor{
  //     width: 20%;
  // }
  // .el-input{
  //     width: 20%;
  // }
}
</style>
<style lang="scss">
.noLeft {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.noLeft2 {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}

.flexBox {
  .el-row {
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .el-radio__label {
      width: 100px;
      display: inline-block;
    }
  }
}
</style>
